import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DocumentoListModel } from "app/models/documento.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { environment } from "environments/environment";
import { Observable, firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class DocumentoService {
    constructor(private httpClient: HttpClient) { }

    adicionar(clienteId: number, arquivo: File, observacao?: string): Observable<RespostaPadrao> {
        const formData = new FormData();
        formData.append('clienteId', clienteId.toString());
        formData.append('arquivo', arquivo, arquivo.name);
        if (observacao) {
            formData.append('observacao', observacao);
        }
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Documento/adicionar`, formData);
    }

    async obterPorCliente(clienteId: number): Promise<DocumentoListModel[]> {
        return firstValueFrom(
            this.httpClient.get<DocumentoListModel[]>(`${environment.urlApi}/Documento/obterPorCliente/${clienteId}`)
        );
    }

    remover(documentoId: number): Observable<RespostaPadrao> {
        return this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/Documento/remover/${documentoId}`);
    }

    download(documentoId: number): Observable<Blob> {
        return this.httpClient.get(`${environment.urlApi}/Documento/download/${documentoId}`, {
            responseType: 'blob'
        });
    }
}
